import { AfterViewInit, Component, ElementRef, inject } from '@angular/core';

@Component({
    selector: 'app-button-toggle-group',
    templateUrl: './button-toggle-group.component.html',
    styleUrls: ['./button-toggle-group.component.scss']
})
export class ButtonToggleGroupComponent implements AfterViewInit {
  private el = inject(ElementRef);


  ngAfterViewInit() {
    this.setDataTestId();
  }

  private setDataTestId() {
    const buttons = this.el.nativeElement.querySelectorAll('button');
    const buttonToggle = this.el.nativeElement.querySelectorAll('mat-button-toggle');

    for (let index = 0; index < buttons.length; index++) {
      const dataTestId = buttonToggle[index].getAttribute('data-testid');

      buttonToggle[index].removeAttribute('data-testid');
      buttons[index].setAttribute('data-testid', dataTestId);
    }
  }
}

